"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TypographyBase = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _tss = require("../styles/tss");
var _compose = _interopRequireDefault(require("../system/compose"));
var _css = _interopRequireDefault(require("../system/css"));
var _display = _interopRequireDefault(require("../system/display"));
var _palette = require("../system/palette");
var _sizing = _interopRequireDefault(require("../system/sizing"));
var _typography = _interopRequireDefault(require("../system/typography"));
var _omit = require("../utilities/omit");
const _excluded = ["component", "children", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const styleFunction = (0, _css.default)((0, _compose.default)(_typography.default, _display.default, _sizing.default, _palette.color));

/**
 * **❗️ DEPRECATED**
 * @deprecated
 */
const TypographyBase = exports.TypographyBase = /*#__PURE__*/_react.default.forwardRef(function Box(props, ref) {
  const {
    css,
    theme,
    cx
  } = (0, _tss.useEmptyStyles)();
  const {
      component: Component = 'span',
      children,
      className
    } = props,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  const styles = styleFunction(_objectSpread({
    theme
  }, props));

  // Omit system props from props by filtering filterProps
  const {
    filterProps
  } = styleFunction;
  const cleanProps = (0, _omit.omit)(rest, filterProps);
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: cx(css(styles), className),
    ref: ref
  }, cleanProps), children);
});
var _default = exports.default = TypographyBase;